const APIS = {
    USER: "usermanagementservice/api/user/",
  };
  
  export default APIS;